export async function sendCustomBroadcastPush({
  notificationTitle,
  notificationBody,
  notificationType = "admin_custom",
  extraData,
  userIds,
}) {
  const title = String(notificationTitle || "").trim();
  const body = String(notificationBody || "").trim();
  if (!title || !body) {
    throw new Error("Título e texto são obrigatórios.");
  }

  const base =
    import.meta?.env?.VITE_API_BASE ||
    "https://trekkin-api-snowy-sunset-6669.fly.dev";

  const res = await fetch(`${base}/admin/notify-custom`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      notificationType,
      notificationTitle: title,
      notificationBody: body,
      extraData,
      userIds: Array.isArray(userIds) ? userIds : undefined,
    }),
  });

  if (!res.ok) {
    const msg = await res.text().catch(() => "");
    throw new Error(msg || `Erro ao enviar notificação (${res.status})`);
  }

  return res.json().catch(() => ({ ok: true }));
}
